import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

export const EU_RETURN_POLICY_TEST_NAME = 'euReturnPolicy';

export const getIsEuReturnPolicyVariant = (): boolean => {
    return getAbTestV2(EU_RETURN_POLICY_TEST_NAME)?.variant === 'variant';
};

export const trackEuReturnPolicyAbTestVariant = (): void => {
    trackAbTestV2Variant(EU_RETURN_POLICY_TEST_NAME);
};
